import {createSelector} from 'reselect';

import type {NutshellState} from '../../../store';

import type {AiAgentState} from './agent-reducer';

export const getAiAgentState = (state: NutshellState): AiAgentState => state.aiAgent;

// @ts-expect-error
export const getAgentEntityContext = createSelector<NutshellState, AiAgentState, string, any>(
    [getAiAgentState],
    (aiAgentState) => aiAgentState
);
